<template>
  <main class="page content" :class="!loading ? '' : 'loading'">
    <div v-if="post">
      <episode :episode="post" v-if="post.postType === 'episode'"></episode>
      <extra :extra="post" v-if="post.postType === 'extra'"></extra>
      <page :page="post" v-if="post.postType === 'page'"></page>
    </div>
  </main>
</template>

<script>
import Episode from './Episode'
import Extra from './Extra'
import Page from './Page'

export default {
  name: 'post',
  data () {
    return {
      post: null,
      loading: true
    }
  },
  components: {
    Episode,
    Extra,
    Page
  },
  mounted () {
    this.fetchPost()
  },
  methods: {
    fetchPost () {
      let vm = this
      if (vm.$route.query.preview_id) {
        // GET /preview => get_preview() [theme-folder]/api/functions.php
        vm.$axios.get('/preview', {
          params: {
            preview_id: vm.$route.query.preview_id
          },
          headers: {
            'X-WP-Nonce': window.wpApiSettings.nonce
          }
        })
        .then((response) => {
          vm.loading = false
          if (response.data) {
            vm.post = response.data
            if (vm.$route.hash) vm.scrollToAnchor()
          } else {
            vm.$router.push('/')
          }
        })
        .catch((err) => {
          console.log(err.response)
          vm.loading = false
          vm.notFound = true
          vm.$router.push('/')
        })
      } else {
        vm.$router.push('/')
      }
    },
    scrollToAnchor () {
      let id = this.$route.hash.replace('#', '')
      process.nextTick(() => {
        document.getElementById(id).scrollIntoView()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// Preview.vue?9ca90ce4